import mapping from "../../../config/mapping";
import PromoProductsSlider from '../PromoProductsSlider/PromoProductsSlider';
import React from "react";

const TabContent = ({ selectedTabOption, items, onLearnMore, labels, isFromListing, promotionDevices}) => {
    const tabContent = mapping.tabContent[selectedTabOption];
    const { className, Component, getTabContent } = tabContent ?? {};

    return (
        <>

            <div className={className}>
                {isFromListing && (
                    <PromoProductsSlider
                        promoProducts={promotionDevices}
                        onLearnMore={onLearnMore}
                        labels={labels}
                        isFromListing={isFromListing}
                        getTabContent={getTabContent}
                    />
                )}
                {items?.map((item, index) => {
                    const componentProps = getTabContent(item, onLearnMore, labels, isFromListing);
                    return (
                        <div
                            key={index}
                            className={`main-card-container ${selectedTabOption}-card-container`}
                            style={selectedTabOption === 'rateplans' ? { marginBottom: '10%' } : {}}>
                            <Component {...componentProps} />
                        </div>
                    );
                })}
            </div>
        </>

    );
};

export default TabContent;
